<template>
  <div>
    <div>
      <div>
        <section class="item-types">
              <div class="row">
                <div class="col-12 text-center">
                  <p class="text">Accessories</p>
                </div>
              </div>
          <div class="row" v-for="(position) in selection" :key="position.position" v-if="position.settings.filter(i => {return i.is_incomplete}).length > 0">
            <div class="col-12">
              <div class="row alt" v-for="(item, key) in position.settings" v-if="item.is_incomplete"
                   :key="key">
                <div class="col-12">
                  <div class="row">
                    <div class="col-9">
                      <h5>{{item.name}}</h5>
                      <p class="text_default">
                        {{item.colour.name}}</p>
                    </div>
                    <div class="col-3 align-middle"
                         @click="openColourSelection(position, key)"
                    >
                      <div class="colours colour_box colours_small">
                        <img class="box__img" :src="item.colour.image" alt="color.colour_name" v-if="item.colour.image">
                        <p v-else-if="item.colour.hexcode">
                          <font-awesome-icon class="large_icon box__img" :style="{color: item.colour.hexcode}" icon="palette"/>
                        </p>
                        <p v-if="!item.colour.image && !item.colour.hexcode">
                          <font-awesome-icon class="large_icon box__img" icon="palette"/>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
            <div class="col-12">
              <hr/>
            </div>
          </div>


          <button type="button" class="btn btn_default" @click.prevent="next">next
          </button>


        </section>

        <transition name="fade" mode="out-in">
          <select-colors v-show="selectColours" @onSelect="setColour"></select-colors>
        </transition>


      </div>
    </div>
  </div>
</template>

<script>

    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

    const SelectColors = () => import('../../../modals/OptionColours');


    export default {
        name: "Accessories",
        data() {
            return {
                checked: null,
                selection: [],
                colour_item: null,
                colour_position: null
            }
        },

        components: {
            SelectColors,
        },

        methods: {

            ...mapMutations('bulkEditor', ['setOption']),
            ...mapActions('bulkEditor', ['update']),

            setColour(c) {
                //let c = this.$store.getters['optionColours/selectedColour'];

                let i = this.colour_position.settings[this.colour_item]

                i.colour = c.colour
                i.is_same_as_frame = c.is_same_as_frame

                this.colour_item = null
                this.colour_position = null

                this.selection = _.map(this.selection, p => {
                    if (p.position === i.position)
                        return i
                    return p
                })

                // this.$store.commit('options/updateColour', {option: 'LOCK', colour: c});
            },

            openColourSelection(position, item) {
                if (position.settings[item].colour_group)
                    this.$store.commit('optionColours/colourGroup', position.settings[item].colour_group);

                this.colour_item = item
                this.colour_position = position

                this.$store.commit('optionColours/openModal', true);
                this.$store.commit('optionColours/getColors');
            },

            selectOption(item, t) {

                _.forEach(this.selection, (i, k) => {
                    i.selected = item.name === i.name;
                    if (i.selected)
                        this.checked = item
                })

            },

            next() {

                this.setOption({
                    o: 'ACC',
                    d: this.selection
                })
                this.update({
                    type: 'option'
                })
            },

        },

        computed: {
            ...mapState('bulkEditor', ['selections']),
            ...mapGetters({
                selectColours: 'optionColours/openModal'
            }),

        },

        created() {
            this.selection = this.selections.options.ACC.items;
        }

    }
</script>

<style scoped lang="scss">

  @import "../../../../assets/scss/utils/vars";

  .form {
    &__label {
      margin-top: 0;
      margin-bottom: 20px;
    }

    &__input {
      border: none;
      border-bottom: 2px solid $navy;
      &:disabled {
        opacity: .6;
      }
    }

    &__radio {
      &:disabled {
        & ~ .form__labelTitle {
          opacity: .6;
          &:hover {
            color: $navy;
            cursor: default;
          }
        }
      }
    }

    &__labelTitle {
      color: $navy;
      text-align: left;
    }
  }

  .lock_side {
    max-height: 250px;
    width: auto;
  }

  .text_white {
    position: absolute;
    bottom: 3rem;
    left: auto;
    right: 2rem;
    display: inline-block;
    width: auto;
  }

  .modal__close {
    color: $green;
  }

  .lockHeight {
    position: relative;
    &__img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }

    &__text {
      position: absolute;
      top: 60%;
      right: 0;
      width: 50%;
    }

  }

  .box {
    margin-bottom: 1rem;
    &__img {
      position: static;
      display: block;
      margin: 0 auto;
      margin-bottom: 20px;
      width: 100%;
      max-width: 160px;
      height: 50px;
    }
    p {
      text-align: center;
    }
  }

  .preloader__img {
    svg {
      height: 25px !important;
    }
  }

  .alt{
    padding: 5px;
  }

  .alt:nth-child(even){
    background-color: rgba(85, 180, 148, 0.4);
  }

</style>
